import * as Sentry from '@sentry/react'

export function initSentry(env) {
  const dsn = env.VITE_SENTRY_DSN
  if (!dsn) {
    return false
  }

  Sentry.init({
    dsn,
    environment: env.VITE_SENTRY_ENV || 'production',
    sendDefaultPii: false,
  })

  return true
}
